import React, { useState } from "react";
import "./datatable.scss";
import { Space, Input, Button, Popover, message, Tag } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useNavigate } from "react-router-dom";
import { useB2BContext } from "../../../context/ContextB2B";
import { AppTable } from "../../common";

interface Contentdata {
  key?: string;
  _id: string;
  full_name?: string;
  email: string;
  user_type: string;
  department: string;
  package_name: string;
  userId: string;
  id: string;
}

function DataTable({
  email,
  setshowModel,
  setEditable,
  isOpen,
  contentData,
  editContent,
  deleteuser,
}: any) {
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const { getUserByID } = useB2BContext();
  const [openPopId, setOpenPopId] = useState<any>(null);

  const columns: ColumnsType<Contentdata> = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      filteredValue: [searchText],
      width: 120,
      sorter: (a: any, b: any) => a._id.localeCompare(b._id),
      render: (text) => <div className="truncate">{text}</div>,
      onFilter: (value, record) => {
        const query = String(value).trim().toLowerCase();
        if (!query) return true;
        return (
          String(record.full_name).toLowerCase().includes(query) ||
          String(record.email).toLowerCase().includes(query) ||
          String(record.user_type).toLowerCase().includes(query) ||
          String(record._id).toLowerCase().includes(query) ||
          String(record.package_name).toLowerCase().includes(query) ||
          String(record.department).toLowerCase().includes(query)
        );
      },
    },
    {
      title: "Name",
      dataIndex: "full_name",
      width: 120,
      key: "full_name",
      render: (text) => <div className="truncate">{text}</div>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 200,
      render: (text) => <div className="truncate">{text}</div>,
    },
    {
      title: "Package",
      dataIndex: "package_name",
      key: "package_name",
      render: (text) => <div className="truncate">{text.toUpperCase()}</div>,
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      width: 100,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <>

          {/* ── Edit ─────────────────────────────────────────── */}
          <button
            className="tbl-action-btn tbl-action-btn--edit"
            style={{marginBottom:"8px"}}
            onClick={() => navigate(`/editemployees?uid=${record._id}`)}
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M8.5 1.5a1.414 1.414 0 012 2L4 10H2V8L8.5 1.5z"
                stroke="currentColor" strokeWidth="1.3"
                strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Edit
          </button>
          
         

          {/* ── Delete ───────────────────────────────────────── */}
          {record.email === getUserByID?.email ? null : (
            <Popover
              open={openPopId === record._id}
              onOpenChange={(v) => setOpenPopId(v ? record._id : null)}
              trigger="click"
              placement="topRight"
              overlayClassName="tbl-action-popover"
              title={null}
              content={
                <div className="tbl-action-pop">
                  <div className="tbl-action-pop__icon">🗑️</div>
                  <p className="tbl-action-pop__msg">
                    <strong>{record?.full_name || record?.email}</strong>
                    <span>This action cannot be undone.</span>
                  </p>
                  <div className="tbl-action-pop__btns">
                    <button
                      className="tbl-action-pop__btn tbl-action-pop__btn--confirm"
                      onDoubleClick={() => {
                        deleteuser(record._id);
                        setOpenPopId(null);
                      }}
                    >
                      Double-click to confirm
                    </button>
                    <button
                      className="tbl-action-pop__btn tbl-action-pop__btn--cancel"
                      onClick={() => setOpenPopId(null)}
                    >
                      Cancel
                    </button>
                  </div>
                  
              
                </div>
                
              }
            >
             
              <button className="tbl-action-btn tbl-action-btn--delete">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M1.5 3h9M4.5 3V1.5h3V3M3.5 3l.5 7.5h4l.5-7.5"
                    stroke="currentColor" strokeWidth="1.3"
                    strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Delete
              </button>
            </Popover>
          )}
        </>
      ),
    },
  ];

  return (
    <div className="dataTable">
      <div className="filterMenu">
        <div></div>
        <Input.Search
          onSearch={(value) => setSearchText(value)}
          onChange={(e) => setSearchText(e.target.value)}
          className="searchField"
          placeholder="Search here..."
        />
      </div>
      <AppTable
        className="dataGrid"
        columns={columns}
        dataSource={contentData}
      />
    </div>
  );
}

export default DataTable;